<template>
    <div class="map-container">
        <gmap-map
            ref="mapRef"
            :center="center"
            :zoom="zoom"
            style="width: 100%; height: 100%"
            :options="options"
        >
            <gmap-info-window
                :options="{ maxWidth: 300 }"
                :position="infoWindow.position"
                :opened="infoWindow.open"
                @closeclick="infoWindow.open = false"
            >
                <slot name="detail">
                    <div ref="infoWindow">
                        <div class="cidade-info" v-if="item.tipo == 'promotor'">
                            <h2>{{ item.nome }}</h2>
                        </div>

                        <div class="lps-box" v-if="item.tipo == 'lps'">
                            <div class="lps-info">
                                <h2 class="lps-name">{{ item.nome }}</h2>
                                <p>
                                    {{ item.endereco + ', ' + item.numero + ' - ' + item.bairro }}
                                </p>
                            </div>
                            <hr />
                            <div class="btn-box">
                                <button
                                    class="save-button"
                                    @click="adicionarAoDia()"
                                    v-text="$t('adicionar-lps-rota')"
                                    v-if="!item.selected"
                                />
                                <button
                                    class="delete-button"
                                    @click="retirarDoDia()"
                                    v-text="$t('excluir-lps-rota')"
                                    v-else
                                />
                            </div>
                        </div>
                    </div>
                </slot>
            </gmap-info-window>

            <gmap-marker
                v-for="(m, index) in clickableMarkers"
                :position="getPosition(m)"
                :clickable="m.tipo != 'cidade'"
                @click="openInfoWindowTemplate(m)"
                :icon="m.svgicon"
                :key="`${index}${m.lat}${m.lng}`"
            />

            <gmap-marker
                v-for="(m, index) in cityMarkers"
                :position="getPosition(m)"
                :clickable="false"
                :icon="m.svgicon"
                :key="`marker${index}${m.lat}${m.lng}`"
            />

            <HeatMapLayer ref="heatMap" v-if="heatmap" :data="hmarkers" :options="heatmapOptions" />
        </gmap-map>
    </div>
</template>

<script>
// import * as VueGoogleMaps from "vue2-google-maps";
import { gmapApi } from 'vue2-google-maps';
import HeatMapLayer from './HeatMapLayer.js';

export default {
    components: {
        HeatMapLayer,
    },
    props: {
        geocoded: {
            default: false,
        },
        clickable: {
            default: false,
        },
        startmarker: {
            default: true,
        },
        day: {
            default: 0,
        },
        dias: {
            type: Array,
            default: () => [],
        },
        zoom: {
            default: 12,
        },
        markers: {
            type: Array,
            default: () => [],
        },
        heatmapMarkers: {
            type: Array,
            default: () => [],
        },
        center: {
            default: () => {
                return {
                    lat: -24.9592027,
                    lng: -53.4608336,
                    nome: 'Cascavel',
                    tipo: 'cidade',
                };
            },
        },
        heatmap: {
            default: false,
        },
        heatmapOptions: {
            type: Object,
            default: () => {},
        },
        options: {
            type: Object,
            default: () => {},
        },
        clickMoveMarker: {
            default: false,
        },
        onClickFunction: {
            type: Function,
            default: (lat, lng) => {},
        },
    },
    data() {
        return {
            markersInner: [],
            geocoder: null,
            infoWindow: {
                position: { lat: 0, lng: 0 },
                open: false,
                template: '',
            },
            mapLoaded: false,
            item: {},
            heatMapInstance: {},
            path:
                'M10.0812 0.00417221V0C10.0537 0 10.0269 0.00166887 10 0.00166887C9.97313 0.00166887 9.94626 0 9.91877 0V0.00417221C4.42628 0.0930404 0 4.64555 0 10.2528C0 17.8089 8.72292 24.9809 10 26C11.2773 24.9811 20 17.8087 20 10.2528C20 4.64555 15.5739 0.0930404 10.0812 0.00417221ZM10.0812 14.663C7.20729 14.663 4.87795 12.2945 4.87795 9.37205C4.87795 6.44879 7.20729 4.0798 10.0812 4.0798C12.9552 4.0798 15.2847 6.44879 15.2847 9.37205C15.2847 12.2945 12.9552 14.663 10.0812 14.663Z',
        };
    },
    created() {
        this.markersInner = Object.assign(this.markers);
    },
    watch: {
        markers: {
            deep: true,
            handler: function () {
                this.markersInner = Object.assign(this.markers);
            },
        },
    },
    mounted() {
        this.$refs.mapRef.$mapPromise.then((map) => {
            this.mapLoaded = true;
            let region = 'BR';

            if (this.mapLoaded) {
                if (!this.heatmap) {
                    this.loadMarkers();
                }
            }

            if (this.clickMoveMarker) {
                // Update lat/long value of div when anywhere in the map is clicked
                google.maps.event.addListener(map, 'click', (event) => {
                    this.center.lat = event.latLng.lat();
                    this.center.lng = event.latLng.lng();
                    this.loadMarkers();
                    this.onClickFunction(this.center.lat, this.center.lng);
                });
            }

            if (this.geocoded) {
                this.geocoder = new google.maps.Geocoder(region);
            }
        });
    },
    computed: {
        google: gmapApi,
        hmarkers: function () {
            if (gmapApi() != null) {
                return this.heatmapMarkers.map((h) => {
                    return {
                        location: new google.maps.LatLng(h.lat, h.lng),
                        weight: h.visible ? 1 : 0.0001,
                    };
                });
            }
        },
        cityMarkers() {
            return this.markersInner.filter(
                (m) => ((m.tipo && m.tipo == 'cidade') || !m.tipo) && !this.clickable
            );
        },
        clickableMarkers() {
            return this.markersInner.filter(
                (m) => this.clickable || (m.tipo && m.tipo != 'cidade')
            );
        },
    },
    methods: {
        codeAddress(address, callbackFunction) {
            this.geocoder.geocode({ address: address }, callbackFunction);
        },
        getPosition: function (marker) {
            return {
                lat: parseFloat(marker.lat),
                lng: parseFloat(marker.lng),
            };
        },
        loadMarkers() {
            this.markersInner = Object.assign(this.markers);

            this.markersInner.forEach((m) => {
                if (m.tipo == 'promotor') return;

                let temp = this.dias[this.day].lpss.find((f) => f.idlps == m.idlps);
                m.selected = temp != undefined;

                if (m.tipo == 'promotor') {
                    m.center.svgicon = {
                        path: this.path,
                        fillColor: '#63C01A',
                        scale: 1.5,
                        fillOpacity: 1,
                        strokeWeight: 0,
                        anchor: new google.maps.Point(15, 15),
                    };
                } else if (m.selected) {
                    m.svgicon = {
                        path: this.path,
                        fillColor: '#FF9800',
                        scale: 1.4,
                        fillOpacity: 1,
                        strokeWeight: 0,
                        anchor: new google.maps.Point(12, 12),
                    };
                } else {
                    m.svgicon = {
                        path: this.path,
                        fillColor: '#7C37C2',
                        scale: 1.3,
                        fillOpacity: 1,
                        strokeWeight: 0,
                        anchor: new google.maps.Point(12, 12),
                    };
                }
            });

            if (this.startmarker) {
                this.center.svgicon = {
                    path: this.path,
                    fillColor: '#63C01A',
                    scale: 1.5,
                    fillOpacity: 1,
                    strokeWeight: 0,
                    anchor: new google.maps.Point(15, 15),
                };
                this.markersInner.push(this.center);
            }
        },
        loadSingleMarker() {
            this.markersInner = [{}];

            if (this.startmarker) {
                this.$refs.mapRef.$mapPromise.then((map) => {
                    this.center.svgicon = {
                        path: this.path,
                        fillColor: '#63C01A',
                        scale: 1.5,
                        fillOpacity: 1,
                        strokeWeight: 0,
                        anchor: new google.maps.Point(15, 15),
                    };

                    this.markersInner.push(this.center);
                });
            }
        },
        openInfoWindowTemplate(item) {
            this.setInfoWindowTemplate(item);
            this.infoWindow.position = this.getPosition(item);
            this.infoWindow.open = true;
        },
        setInfoWindowTemplate(item) {
            this.item = item;
        },
        updateMarker(adding, item = this.item) {
            if (!item) {
                return;
            }
            if (item.idlps) {
                item = this.markersInner.filter((m) => m && m.idlps == item.idlps)[0];
            }
            if (item) {
                item.selected = adding;
                item.svgicon.fillColor = adding ? '#FF9800' : '#7C37C2';
                item.svgicon.scale = adding ? 1.2 : 1;
                item = this.markersInner.filter((m) => m && m.idlps == item.idlps)[0];
                this.markersInner.splice(this.markersInner.indexOf(item), 1);
                setTimeout(() => {
                    this.markersInner.push(item);
                }, 10);
            }
        },
        adicionarAoDia() {
            /*
                @70116 - Adicionado essa variavel para criar um novo item
                para ter uma nova referência no array de lpss.
            */
            let newItem = { ...this.item };
            this.dias[this.day].lpss.push(newItem);
            this.updateMarker(true);
        },
        retirarDoDia() {
            let lps = this.dias[this.day].lpss.filter((l) => l.idlps == this.item.idlps)[0];
            if (lps) {
                this.dias[this.day].lpss.splice(this.dias[this.day].lpss.indexOf(lps), 1);
                this.updateMarker(false);
            }
        },
        addCustomControl(position, element) {
            /*  POSIÇÕES (referência https://developers.google.com/maps/documentation/javascript/controls):
             *
             *  TOP_LEFT (1)        TOP/TOP_CENTER (2)          TOP_RIGHT (3)
             *  LEFT_TOP/LEFT (5)                               RIGHT_TOP (7)
             *
             *  LEFT_CENTER (4)                                 RIGHT_CENTER (8)
             *
             *  LEFT_BOTTOM (6)                                 RIGHT_BOTTOM (9)
             *  BOTTOM_LEFT (10)    BOTTOM/BOTTOM_CENTER (11)   BOTTOM_RIGHT (12) */

            if (this.$refs.mapRef.$mapPromise != undefined) {
                this.$refs.mapRef.$mapPromise.then((map) => {
                    map.controls[position].push(element);
                });
            } else {
                console.error('Mapa não disponível para adicionar controles customizados.');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 15px;
    height: 100%;
}

img {
    width: 240px;
    height: 360px;
}
.map-container {
    width: 100%;
    height: 100%;
    clear: both;
}

.lps-box {
    padding-bottom: 5px;

    .lps-info {
        min-height: 50px;
    }

    .lps-name {
        color: $primary-color-click;
        font-weight: 600;
        text-transform: uppercase;
    }

    hr {
        margin: 0.75rem 0;
    }

    .btn-box {
        display: flex;
        justify-content: center;
    }
}

.lps-box .save-button,
.lps-box .delete-button {
    position: relative;
    float: right;
    color: $sovis-white;
    font-size: 12px;
    text-align: center;
    padding: 5px 10px;
    min-width: 150px;
    min-height: 30px;
    margin-left: 10px;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    @include gradient-button();
}

.lps-box .delete-button {
    color: $darker-gray-color;
    @include exclude-button();
}

.cidade-info {
    min-width: 200px;
    min-height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    h2 {
        color: $primary-color-click;
        font-weight: 600;
        text-transform: uppercase;
    }
}
</style>
